import { render, staticRenderFns } from "./Atick.vue?vue&type=template&id=549739aa&scoped=true&"
import script from "./Atick.vue?vue&type=script&lang=ts&"
export * from "./Atick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549739aa",
  null
  
)

export default component.exports